export default function textVoiceHash(text, voiceId) {
  return text.toLowerCase().trim() + `__voiceid:${voiceId}`;
};
